import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from 'environments/environment';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { UiService } from 'app/dp-world/services/ui.service';
import { ConstantsService } from 'app/dp-world/services/constants.service';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthService,
    private ui: UiService,
    private router: Router,
    private contants: ConstantsService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // add authorization header with basic auth credentials if available
    const currentUser = this.authenticationService.currentUserValue;

    // const isHandset = this.uiService.isHandsetChanged.getValue();
    if (!request.url.includes('assets/data/menu.json')) {
      if (request.url.includes('clientmanagement-api')) {
        const headers = {
          'Authorization': "Bearer " + currentUser.token,
          'x-client-type-code': currentUser.client_type_code || environment.clientTypeCode,
          'x-company-reference': currentUser.mawani_org_reference_id || environment.companyReference,
          'x-service-provider-code': currentUser.tenant_code || environment.serviceProviderCode
        };
        request = request.clone({
          setHeaders: headers
        });
      } else if (request.url.includes('documentmanagement-api') || request.url.includes('referential-api')) {
        const headers = {
          'Authorization': "Bearer " + currentUser.token,
          'x-client-type-code': environment.clientTypeCode,
          'x-company-reference': environment.companyReference,
          'x-service-provider-code': environment.serviceProviderCode
        };
        request = request.clone({
          setHeaders: headers
        });
      } else if (currentUser && currentUser.token) {
        const headers = {
          [environment.HEADER.X_USER_TOKEN]: currentUser.token,
          'x-user-id': currentUser.user_id || '',
          // [environment.HEADER.X_DISPLAY_MODE]: 'web'
          // [environment.HEADER.X_DISPLAY_MODE]: isHandset ? 'mobile' : 'web'
        };
        if (!currentUser.hasOwnProperty('skipTenantInGlobalHeader')) {
          const tenantCode = this.authenticationService.getTenantCode();
          if (tenantCode) {
            headers[environment.HEADER.X_TENANT_CODE] = tenantCode;
          }
        }
        if (currentUser.organisation_id) {
          headers[environment.HEADER.X_ORG_ID] = (currentUser.organisation_id + '') || '';
        }
        request = request.clone({
          setHeaders: headers
        });

      } else {
        const currentRequestHeader = request.headers;
        const reqHeaders = {
          [environment.HEADER.X_DISPLAY_MODE]: 'web',
          // [environment.HEADER.X_DISPLAY_MODE]: isHandset ? 'mobile' : 'web'
        };
        const publicUrlIndex = this.contants.publicApiListForExtBCOTermsAcceptance.findIndex((url) => request.url.includes(url));
        if (publicUrlIndex === -1) {
          reqHeaders[environment.apiKey] = environment.apiValue;
        }
        const tenantCode = this.authenticationService.getTenantCode();
        if (tenantCode) {
          reqHeaders[environment.HEADER.X_TENANT_CODE] = tenantCode;
        } else if (currentRequestHeader && currentRequestHeader[environment.HEADER.X_TENANT_CODE]) {
          reqHeaders[environment.HEADER.X_TENANT_CODE] = currentRequestHeader[environment.HEADER.X_TENANT_CODE];
        }
        request = request.clone({
          setHeaders: reqHeaders
        });
      }

      return next.handle(request).pipe(
        tap(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              const token = event.headers.get(environment.HEADER.X_USER_TOKEN);
              if (token && currentUser) {
                // //console.log(
                //   '%c token intercepted=' + token,
                //   'color: lightgreen'
                // );
                currentUser.token = token;
              }
            }
          },
          (error: any) => {

            if (error instanceof HttpErrorResponse) {

              console.log('error.status: ' + error.status);
              console.log('error: ', error);

              // authorization has expired
              if ([440, 401].includes(error.status)) {

                if (error.url.includes('notifications')) {
                  return;
                }
                const logoutMsg = 'You are not authorized to access that page.';
                this.authenticationService.logout();
                setTimeout(() => {
                  this.ui.closeCurrentSnackbar();
                  this.ui.snackbar(logoutMsg, 5000);
                }, 0);
                if (this.router.url.includes('home/def') && window.location.host !== 'localhost:9876') {
                  setTimeout(() => {
                    window.location.reload();
                  }, 5000);
                }
                // apparently this happens for many issues, including internet disconnected
              } else if (error.status === 400 && error.error && error.error.errorCode === 42910) {
                const errorMsg = error.error.errorMessage
                  ? error.error.errorMessage
                  : 'Request Limit Exceeded, Please try again after some time.';
                this.authenticationService.logout();
                setTimeout(() => {
                  this.ui.closeCurrentSnackbar();
                  this.ui.snackbar(errorMsg, 5000);
                }, 0);
              } else if ([0].includes(error.status)) {

                if (navigator && !navigator.onLine) {
                  console.error('not connected to internet', 'Network');
                  this.router.navigate(['/error-handling/def'], { queryParams: {} });
                }
                /* this shouldn't be neccessary anymore.
                else {
                  this.ui.snackbar('Your login has expired, please login again.');
                  this.router.navigate(['/home/def'], { queryParams: { returnUrl: this.router.url } });
                }*/
              }
            }
          }
        )
      );
    } else {
      return next.handle(request);
    }
  }
}
